var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.iconTabFromState.length > 0)?_c('font-awesome-icon',{class:_vm.classFromState,attrs:{"icon":_vm.iconTabFromState,"size":"lg"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }